export const numberOfQuestions = (survey) => {
    let size = 0;
    survey.json.pages.map((page) => {
        size+=page.elements.length;
        return page;
    })
    return size;
}